<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">{{ $t('calendar.name') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">{{ $t('calendar.name') }}</h1>
          <p class="lead text-muted">
            {{ $t('bookings.name') }}
            {{ $t('forProperty') }}
            {{property.name}}
          </p>
        </div>
      </header>

      <div class="content">
        <FullCalendar
          height="auto"
          ref="calendar"
          :firstDay="1"
          :defaultDate="date"
          defaultView="dayGridMonth"
          displayEventTime="false"
          :locale="$i18n.locale"
          :plugins="calendarPlugins"
          :events="events"
          :validRange = "{
            start: minDate,
          }"
          @dateClick="addBooking"
          @eventClick="fetchBooking"
          :datesRender="fetchBookings"
          :customButtons="customButtons"
          :buttonText="{
            today: $t('today'),
            month: $t('month'),
            week: $t('week'),
            day: $t('day'),
            list: $t('list')
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';

import '@fullcalendar/core/locales/sl';
import '@fullcalendar/core/locales/uk';


export default {
  name: 'Calendar',
  props: ['socket'],
  data: () => ({
    minDate: moment().subtract('1', 'year').startOf('year').format('YYYY-MM-DD'),
    title: '',
    year: '',
    month: '',
    date: '',
    property: {},
    bookings: [],
    events: [],
    calendarPlugins: [
      dayGridPlugin,
      interactionPlugin
    ],
    customButtons: {}
  }),
  filters: {
    monthName: function(month){
      if(!month) return '';
      return moment(month, 'M').format('MMMM');
    }
  },
  components: {
    FullCalendar
  },
  created(){
    this.date = this.$route.params.year && this.$route.params.month ? this.$route.params.year + '-' + moment(this.$route.params.month, "M").format('MM') + '-01' : moment().format('YYYY-MM-DD');
    this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);

    this.customButtons = {
      today: {
        text: this.$t('today'),
        click: () => {
          this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('calendar.url'))
        }
      },
      prev: {
        text: "prev",
        click: () => {
          if(this.date == moment().add(1, 'month').startOf('month').format('YYYY-MM-DD')){
            return this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('calendar.url'));
          }
          this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('calendar.url') + '/' + moment(this.date, 'YYYY-MM').subtract(1, 'month').format('YYYY') + '/' + moment(this.date, 'YYYY-MM').subtract(1, 'month').format('M'))
        }
      },
      next: {
        text: "next",
        click: () => {
          if(this.date == moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')){
            return this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('calendar.url'));
          }
          this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('calendar.url') + '/' + moment(this.date, 'YYYY-MM').add(1, 'month').format('YYYY') + '/' + moment(this.date, 'YYYY-MM').add(1, 'month').format('M'))
        }
      }
    }
  },
  mounted() {
    this.socket.on('newBooking', (data) => {
      data = JSON.parse(data);
      if(this.property._id == data.property._id && data.booking){

        let event = this.createEvent(data.booking);
        let calendar = this.$refs.calendar.getApi();

        const updatedEvent = calendar.getEventById(event.id);

        if(data.booking.status == '0') updatedEvent.remove();

        if(updatedEvent){
          updatedEvent.setProp('title', event.title);
          updatedEvent.setDates(Date.parse(event.start), Date.parse(event.end));
          updatedEvent.setProp('backgroundColor', event.backgroundColor);
          updatedEvent.setProp('textColor', event.textColor);
        }else{
          this.events.push(event);
        }
      }
    })
  },
  beforeDestroy(){
    this.socket.off('newBooking')
  },
  methods: {
    addBooking: function(date) {
      if(moment(date.dateStr).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')){
        return;
      }
      window.sessionStorage.setItem("date", date.dateStr);
      return this.$router.push('/' + this.$i18n.locale + '/' + this.property.slug + '/' + this.$t('bookings.url') + '/' + this.$t('create'));
    },

    fetchBooking: function(ev) {
      return this.$router.push('/' + this.$i18n.locale + '/' + this.$t('bookings.url') + '/' + ev.event.id);
    },

    fetchBookings: function(el){
      this.month = moment(el.view.currentStart).format('M');
      this.year = moment(el.view.currentStart).format('YYYY');
      let start = el.view.activeStart;
      let end = el.view.activeEnd;
      this.date = moment(el.view.currentStart).format('YYYY-MM-DD');
      fetch(process.env.VUE_APP_API + '/bookings?propertyId=' + this.property._id + '&startDate=' + moment(start).format('YYYY-MM-DD') + '&endDate=' + moment(end).format('YYYY-MM-DD'), {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        if(response.status == 403 || response.status == 401){
          this.$router.push('/login');
        }else{
          return response.json();
        }
      })
      .then(result => {
        this.bookings = result;
        let events = [];
        this.bookings.forEach(function(booking){
          booking.status == '0' || events.push(this.createEvent(booking));
        }, this)
        this.events = events;
      });
    },

    createEvent: function(booking){
      let textColor = '#000000';
      let backgroundColor;
      if(booking.status == "0"){
        backgroundColor = "d3d3d3"
      }else if(booking.payer.phone.error){
        backgroundColor = "dc3545";
      }else if(booking.status == "1" || booking.status == "2"){
        backgroundColor = "ffffff";
        if(booking.guests.length >= booking.numGuests.adults + booking.numGuests.children){
          backgroundColor = "ffc107";
          if(!booking.guests.find(g => !g.index)){
            backgroundColor = "009b72";
          }
        }
      }else if(booking.status == "3"){
        backgroundColor = "17a2b8";
      }else if(booking.status == "4"){
        backgroundColor = "000000"
      }

      if(backgroundColor){
        //set dark or light text color, based on background color
        var r = parseInt(backgroundColor.substr(0,2),16);
        var g = parseInt(backgroundColor.substr(2,2),16);
        var b = parseInt(backgroundColor.substr(4,2),16);
        textColor = ((r*299)+(g*587)+(b*114))/1000 > 128 ? '#000000' : '#ffffff';
      }

      return {
        id: booking._id,
        title: (booking.unitId ? (booking.room.units && booking.room.units[booking.unitId - 1] ? booking.room.units[booking.unitId - 1].name : booking.unitId) + ' - ' : "")
          + (booking.status == 4 ? this.$t('closed') : booking.payer.name.first + ' ' + booking.payer.name.last)
          + ' - ' + (this.property.rooms.find(room => room._id == booking.room._id) ? this.property.rooms.find(room => room._id == booking.room._id).name : ""),
        start: booking.night.first + ' ' + this.property.time.checkIn,
        end: booking.night.last + ' ' + this.property.time.checkOut,
        backgroundColor: "#" + backgroundColor,
        borderColor: "#000000",
        textColor: textColor
      }
    }
  },
  watch: {
    $route(){
      this.date = this.$route.params.year && this.$route.params.month ? this.$route.params.year + '-' + moment(this.$route.params.month, "M").format('MM') + '-01' : moment().startOf('month').format('YYYY-MM-DD')
      let calendarApi = this.$refs.calendar.getApi();
      calendarApi.gotoDate(this.date);
    }
  }
}
</script>

<style>
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';
  .fc-time{
    display: none;
  }
</style>

<i18n>
{
  "en": {
    "calendar": {
      "name": "Calendar",
      "url": "calendar"
    },
    "bookings": {
      "name": "Bookings",
      "url": "bookings"
    },
    "closed": "Closed",
    "forProperty": "for property",
    "create": "create",
    "today": "today",
    "month": "month",
    "week": "week",
    "day": "day",
    "list": "list"
  },
  "sl": {
    "calendar": {
      "name": "Koledar",
      "url": "koledar"
    },
    "bookings": {
      "name": "Rezervacije",
      "url": "rezervacije"
    },
    "closed": "Zaprto",
    "forProperty": "nastanitve",
    "create": "ustvari",
    "today": "danes",
    "month": "mesec",
    "week": "teden",
    "day": "dan",
    "list": "seznam"
  }
}
</i18n>
